export default "__VITE_ASSET__BlKk6B43__"